import { ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export const ChatComposer = ({ value, onChange, onSubmit, disabled }) => {
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      onSubmit(event);
    }
  };

  return (
    <form className="chat-composer" onSubmit={onSubmit} data-testid="chat-composer-form">
      <Textarea
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Ask a perimenopause question"
        aria-label="Your question"
        disabled={disabled}
        maxLength={4000}
        rows={1}
        data-testid="chat-input-textarea"
      />
      <Button
        type="submit"
        size="icon"
        disabled={disabled || !value.trim()}
        aria-label="Send message"
        data-testid="send-message-button"
      >
        <ArrowUp aria-hidden="true" />
      </Button>
    </form>
  );
};